import { render, staticRenderFns } from "./ContentInsights.vue?vue&type=template&id=463a6307"
import script from "./ContentInsights.vue?vue&type=script&lang=js"
export * from "./ContentInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports